


























import Vue from 'vue';

export default Vue.extend({
  props: {
    description: {
      type: String,
    },
    title: {
      type: String,
      default: 'GENERAL.TITLE.YOU_NEED_TO_UPGRADE_TO',
    },
  },
  computed: {
    defaultDescription() {
      return this.$t('GENERAL.TEXT.THIS_IS_A_BIG_STEP_IN_YOUR_JOURNEY');
    },
  },
  methods: {
    upgrade() {
      this.$emit('close');
      this.$router.push({ name: 'settings-adjust-plan' });
    },
  },
});
